import { useNavigate } from "react-router";

//Common
import {
  DataGrid,
  Drawer,
  ConfirmationDialog,
  Snackbar,
} from "../../common/VFX-UI";
import PageHeader from "../../common/PageHeader/PageHeader";
import { MoreActionButton } from "../../common/Buttons";
import SearchContainer from "../../common/Forms/SearchContainer/SearchContainer";

//App
import useComponentGeneralStyles from "../../styles";
import { RoleProps } from "../../../types/role";
import useRole from "./hooks/useRole";
import RoleFormContainer from "./RoleFormContainer";
import RoleView from "./RoleView";
import RoleMoreActionsMenu from "./RoleMoreActionsMenu";
import { hasRole } from "../../../utility/helpers/claimHelper";
import { RoleDto } from "../../../app/model/api/types/dto";
import { SYSTEM_ADMIN } from "../../Users/constants";

const Role: React.FC<RoleProps> = (props) => {
  const { data: roles, deleteMutation } = props;
  const generalStyles = useComponentGeneralStyles();
  const navigate = useNavigate();

  const {
    state,
    formContext,
    rowEvents,
    actionColumnAnchorEl,
    toggleNewViewHandler,
    toggleViewHandler,
    toggleEditViewHandler,
    toggleDeactivateHandler,
    handleDeactivate,
    onShowSuccess,
    onAddSnackbarClose,
    handleActionClick,
    setActionColumnAnchorEl,
  } = useRole({
    deleteMutation: deleteMutation,
  });

  const rolesPermited =
    roles &&
    roles.filter((item: RoleDto) => item.id !== SYSTEM_ADMIN.toLowerCase());

  const openMenu = Boolean(actionColumnAnchorEl);

  const columns = [
    {
      dataField: "id",
      text: "ID",
      hidden: true,
    },
    {
      dataField: "name",
      text: "Name",
      sort: true,
    },
    {
      dataField: "action",
      text: "",
      style: { width: "25px" },
      isDummyField: true,
      formatter: () => {
        return (
          <MoreActionButton handleActionClick={(e) => handleActionClick(e)} />
        );
      },
    },
  ];

  return (
    <>
      <>
        <PageHeader>Role</PageHeader>
        <div style={generalStyles.searchContainer}>
          <SearchContainer
            toggleNewViewHandler={toggleNewViewHandler}
            newButtonStyle={{ height: "100%" }}
          />
        </div>
      </>

      <Drawer show={state.toggleNewForm}>
        {state.toggleNewForm && (
          <RoleFormContainer
            onClose={toggleNewViewHandler}
            onShowSuccess={onShowSuccess}
          />
        )}
      </Drawer>

      <Drawer show={state.toggleEditForm}>
        {state.toggleEditForm && formContext?.data && (
          <RoleFormContainer
            onClose={toggleEditViewHandler}
            onShowSuccess={onShowSuccess}
          />
        )}
      </Drawer>

      <Drawer show={state.toggleView}>
        {state.toggleView && formContext?.data && (
          <RoleView
            onClose={toggleViewHandler}
            editAction={() => {
              toggleEditViewHandler();
            }}
            toggleDeactivateHandler={toggleDeactivateHandler}
          />
        )}
      </Drawer>

      <DataGrid
        columns={columns}
        data={rolesPermited}
        keyField="id"
        defaultSorted={[{
          dataField: 'name',
          order: 'asc'}]}
        rowEvents={rowEvents}
      />

      {actionColumnAnchorEl && (
        <RoleMoreActionsMenu
          isOpen={openMenu}
          target={actionColumnAnchorEl}
          toggle={() => {
            setActionColumnAnchorEl(null);
          }}
          onViewClick={() => {
            toggleViewHandler();
            setActionColumnAnchorEl(null);
          }}
          onPermissionClick={
            !hasRole([formContext?.data?.name ?? ""])
              ? () => {
                  navigate(`/settings-page/role-permissions/${formContext?.id}`);
                }
              : undefined
          }
        />
      )}

      <ConfirmationDialog
        open={state.isDeactivateDialogOpen}
        onClose={toggleDeactivateHandler}
        onConfirm={handleDeactivate}
        contentTitle={`Deactivate ${formContext?.data?.name}`}
        contentText={"Are you sure you want to continue?"}
        confirmText={"Yes, Continue"}
        closeText={"No, Go Back"}
      ></ConfirmationDialog>

      {state.showSuccessSnackbar && (
        <Snackbar
          open={state.showSuccessSnackbar}
          message={state.successMessage}
          handleClose={onAddSnackbarClose}
          severity="success"
        />
      )}
    </>
  );
};

export default Role;
